import * as React from 'react'
import Logo from './logo'
import Button from '../Default'
import { makeStyles } from '@material-ui/core/styles'
import { blue } from '@material-ui/core/colors'

export default function Index({ children, ...props }) {
  const s = useStyle({})

  return (
    <Button className={s.button} {...props}>
      <Logo className={s.logo} />
      {children}
    </Button>
  )
}

const useStyle = makeStyles({
  button: {
    backgroundColor: blue[400],
    fontWeight: 600,
    color: '#FFF',
    borderRadius: 25,
    '&:hover': {
      backgroundColor: blue[300],
    },
  },
  logo: {
    position: 'absolute',
    left: 20,
  },
})
